export async function createPaymentMethod(
  stripe: any,
  card: any,
  orgName: string
) {
  return stripe.createPaymentMethod({
    type: "card",
    card: card,
    billing_details: {
      name: orgName
    }
  });
}
